module.exports = __webpack_public_path__ + "static/media/feature-3.f5aad056.svg";